<template>
    <select-label
        v-model="selectedItems"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="selectableItems"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        :label="label"
        multiple
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorMultipleFilterItems',
    components: {
        SelectLabel,
    },
})
export default class SelectorMultipleFilterItems extends Vue {
    @Prop({ type: [Array], default: () => [] }) readonly value: Array<string> | Array<number>;
    @Prop({ default: false }) readonly disabled: boolean;
    @Prop({ default: true }) readonly editable: boolean;
    @Prop({ default: undefined }) readonly label: string;
    @Prop({ default: () => [{}] }) readonly itemList: Array<any>;
    @Emit()
    public input(val: Array<string> | Array<number>) {}

    get selectedItems(): Array<string> | Array<number> {
        return this.value;
    }
    set selectedItems(newVal: Array<string> | Array<number>) {
        this.input(newVal);
    }
    get selectableItems() {
        return this.itemList.map(kv => {
            return { text: (this as any).$t(kv.text_key), value: kv.value };
        });
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
}
</script>
